var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"text-h3 mb-5"},[_vm._v(_vm._s(_vm.userName))]),_c('p',[_vm._v("Добро пожаловать!")]),_c('p',[_vm._v("Можешь выбрать слева в меню, интересующий тебя раздел.")])])}
var staticRenderFns = []

export { render, staticRenderFns }